import { useUsers } from '@/core/api/users';
import type { Author } from '@/core/api/utils/typeUtils';
import { getDisplayName } from '@/core/utils';

// TODO: extend to use it in event log; discuss with UX team how to consistently show author in UI
export const useGetAuthorName = () => {
	const users = useUsers();

	return (author: Author) => {
		if (author['@kind'] === 'USER') {
			if (!users.data) {
				// Loading, but we don't want to show a loader or some fake text
				return '';
			}

			const user = users.data.find((u) => u.userInfo.userId === author['@id']);

			return user ? getDisplayName(user.userInfo) : 'Unknown user';
		}

		if (author['@kind'] === 'SYSTEM' || author['@kind'] === 'API') {
			return 'System';
		}

		return 'N/A';
	};
};
